<template>
    <div style="padding-bottom: 40px" id="system-setting">
        <div class="info-view" @keyup.enter="saveSystemType()" v-if="sysInfo">
            <div class="info-view-title">硬件服务器类型管理</div>
            <div class="info-view-main">
                <div class="info-view-item" style="align-items: flex-start;height:36px;">
                    <span style="text-align: left">硬件服务器类型：</span>
                    <span v-if="!systemTypePopShow">{{systemType | showSystemTypeName}}</span>
                    <el-select size="mini" v-else style="width: 120px" v-model="systemTypeSelected"
                               @change="handleSystemTypeChange(systemTypeSelected)">
                        <el-option
                                v-for="item in systemTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="info-view-item" style="align-items: flex-start;height: 36px;">
                    <span style="text-align: left">是否带分层：</span>
                    <span v-if="!systemTypePopShow">{{isNode | showIsNode}}</span>
                    <el-select size="mini" v-else style="width: 120px" v-model="isNodeSelected"
                               @change="handleIsNodeChange(isNodeSelected)">
                        <el-option
                                v-for="item in isNodeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!systemTypePopShow && $store.getters.checkChangeAuth()"
                               @click="systemTypePop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="systemTypePopShow" @click="saveSystemType()">
                        保存
                    </el-button>
                    <el-button size="small" type="info" v-if="systemTypePopShow" @click="systemTypePopShow = false">取消
                    </el-button>
                </div>
            </div>
        </div>
        <div class="info-view">
            <div class="info-view-title">设备引擎升级</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">检查当前版本并对设备引擎进行升级</span>

                <div class="info-view-item" style="align-items: flex-start;height: auto">
                    <span style="height: 30px;line-height: 30px">当前引擎版本：</span>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start">
                        <div style="display: flex;flex-direction: column;align-items: flex-start;">
                            <template v-for="(item, index) in engineList">
                                <span :key="index" style="height: 30px;display: flex;align-items: center">{{item.engineTypeName}} - {{item.versionCode}}</span>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" @click="goUploadEnginePackage"
                               v-if="$store.getters.checkChangeAuth()">上传升级包
                    </el-button>
                    <el-button size="small" type="primary" @click="goCardUpdate"
                               v-if="$store.getters.checkChangeAuth()">升级管理
                    </el-button>

                    <el-button size="small" type="primary" @click="checkEngineUpdate">检测更新</el-button>
                </div>
            </div>
        </div>
        <div class="info-view">
            <div class="info-view-title">系统空间清理</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">可对系统缓存进行一键清理，并可按上传日期清理文件分发内的文件</span>

                <div class="info-view-item" style="align-items: flex-start;height: auto">
                    <span style="height: 30px;line-height: 30px">系统当前空间占用：{{(usedSpace/(1024*1024*1024)).toFixed(2)}}GB/{{(totalSpace/(1024*1024*1024)).toFixed(2)}}GB({{(usedSpace*100/totalSpace).toFixed(2)}}%)</span>
                </div>

                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" @click="cleanChunkFile"
                               v-if="$store.getters.checkChangeAuth()">清理系统缓存
                    </el-button>
                    <el-button size="small" type="primary" @click="goFileIssueClean"
                               v-if="$store.getters.checkChangeAuth()">清理文件分发
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo" class="info-view" @keyup.enter="savePrepareDownLimit()">
            <div class="info-view-title">预下载限速</div>
            <div class="info-view-main">
                <div class="info-view-item">
                    <span>云机升级包预下载速度限制：</span>
                    <span v-if="!prepareDownLimitPopShow">{{prepareDownLimit}}</span>
                    <el-input v-else size="mini" v-model="prepareDownLimit" style="width: 150px"></el-input>
                    <span>kb/s</span>
                    <el-tooltip effect="dark" placement="right">
                        <div slot="content">调整云机下载升级包的速度，请将速度设置在合理的范围内，<br/>
                            以免影响云机的正常业务，默认为2000kb/s，设置为0表示不限制。
                        </div>
                        <div class="question-icon">?</div>
                    </el-tooltip>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary"
                               v-if="!prepareDownLimitPopShow && $store.getters.checkChangeAuth()"
                               @click="prepareDownLimitPop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="prepareDownLimitPopShow"
                               @click="savePrepareDownLimit()">
                        保存
                    </el-button>
                    <el-button size="small" type="info" v-if="prepareDownLimitPopShow"
                               @click="prepareDownLimitPopShow = false">取消
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo" class="info-view" @keyup.enter="saveSysInfo(changePopInfo)">
            <div class="info-view-title">接口认证</div>
            <div class="info-view-main">
                <div class="info-view-item">
                    <span>静态token开关：</span>
                    <el-switch v-if="!tokenPopShow" v-model="sysInfo.isCloseToken" :active-value="'1'"
                               :inactive-value="'0'"
                               :disabled="true" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-switch v-else size="mini" v-model="changePopInfo.isCloseToken" :active-value="'1'"
                               :inactive-value="'0'"
                               active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-tooltip effect="dark" placement="right">
                        <div slot="content">静态token关闭时，用户登录后生成token，30分钟闲置失效，<br/>
                            每次执行操作刷新时间。失效后需重新登录才能生成。<br/>
                            静态token开启后，将生成一个不会失效的超级用户token，<br/>重新开关会刷新此token。<br/>
                        </div>
                        <div class="question-icon">?</div>
                    </el-tooltip>
                </div>
                <!--<span class="info-view-item" style="font-size: 12px">userid：{{changePopInfo.closeTokenUserId}}</span>-->
                <div style="display: flex;flex-direction: row;">
                    <span class="info-view-item" style="font-size: 12px">超级用户：</span>
                    <el-select v-model="adminUserName" placeholder="请选择" size="small" style="width: 140px;"
                               v-if="tokenPopShow && (sysInfo.isCloseToken == 1 || changePopInfo.isCloseToken == 1)"
                               @change="changeTokenUser(adminUserName)">
                        <el-option
                                v-for="item in userList"
                                :key="item.id"
                                :label="item.username"
                                :value="item.username">
                        </el-option>
                    </el-select>
                    <span class="info-view-item" style="font-size: 12px" v-else>{{adminUserName}}</span>
                </div>
                <span class="info-view-item" style="font-size: 12px">静态token：{{staticToken}}</span>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!tokenPopShow && $store.getters.checkChangeAuth()"
                               @click="tokenPop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="tokenPopShow" @click="saveSysInfo(changePopInfo)">保存
                    </el-button>
                    <el-button size="small" type="info" v-if="tokenPopShow" @click="cancelTokenSet()">取消</el-button>
                </div>
            </div>
        </div>
        <div class="info-view">
            <div class="info-view-title">数据库备份恢复</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">备份数据库文件，并从数据库文件中恢复</span>
                <span class="info-view-item" style="font-size: 12px">当前数据库版本：{{systemVersion}}</span>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="$store.getters.checkChangeAuth()"
                               @click="backupDatabase">备份
                    </el-button>
                    <el-button size="small" type="primary" v-if="$store.getters.checkChangeAuth()"
                               @click="recoverDatabasePop">从数据库文件恢复
                    </el-button>
                </div>
            </div>
        </div>
        <div class="info-view" v-if="phoneModelSwitch">
            <div class="info-view-title">设备机型池</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">本地模式<el-switch
                        class="model-switch" @change="modelSwitchHandle"
                        size="mini" v-model="phoneModelSwitch.paramValue" :active-value="'1'"
                        :inactive-value="'0'" active-text="开" inactive-text="关"
                        active-color="#40dfd0"></el-switch>
                <span style="color: red; text-align: center;margin-left: 15px;"
                      v-if="phoneModelSwitch.paramValue == '1'">注: 本地模式开启后，仅使用本地机型库的内容
                </span>
</span>
            </div>
        </div>
        <div class="info-view">
            <div class="info-view-title">管理系统升级</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">检查当前版本并对管理系统进行升级</span>
                <div class="info-view-item">
                    <span>前端版本：</span>
                    <span>2.0.0</span>
                </div>
                <div class="info-view-item">
                    <span>后台版本：</span>
                    <span>{{systemVersion}}</span>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" @click="systemUpdatePopShow = true"
                               v-if="$store.getters.checkChangeAuth()">升级
                    </el-button>
                    <el-button size="small" type="primary" @click="checkSystemUpdate"
                               v-if="$store.getters.checkChangeAuth()">检测更新
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo" class="info-view" @keyup.enter="saveSysInfo(changePopInfo)">
            <div class="info-view-title">系统网络设置</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">配置管理中心网络及远程相机服务网络</span>
                <div class="info-view-item">
                    <span>管理中心网络IP<span v-show="changePopShow" style="color: red;">*</span>：</span>
                    <span v-if="!changePopShow">{{sysInfo.webIp}}</span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.webIp"
                                  :style="{width: '150px', border: checkInfo.webIp ? '1px solid red' : ''}"></el-input>
                        <span v-show="checkInfo.webIp" style="color: red;padding-left: 10px">请输入有效的公网IP地址。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>管理中心网络端口<span v-show="changePopShow" style="color: red;">*</span>：</span>
                    <span v-if="!changePopShow">{{sysInfo.webPort}}</span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.webPort"
                                  :style="{width: '150px', border: checkInfo.webPort ? '1px solid red' : ''}"></el-input>
                        <span v-show="checkInfo.webPort" style="color: red;padding-left: 10px">请输入有效的网络端口号。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>管理中心网络子网掩码<span v-show="changePopShow" style="color: red;">*</span>：</span>
                    <span v-if="!changePopShow">{{sysInfo.webMask}}</span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.webMask"
                                  :style="{width: '150px', border: checkInfo.webMask ? '1px solid red' : ''}"></el-input>
                        <span v-show="checkInfo.webMask" style="color: red;padding-left: 10px">请输入有效的子网掩码。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>公网IP<span v-show="changePopShow" style="color: red;">*</span>：</span>
                    <span v-if="!changePopShow">{{sysInfo.extranetIp}}</span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.extranetIp"
                                  :style="{width: '150px'}"></el-input>
                        <!--<span v-show="checkInfo.extranetIp" style="color: red;padding-left: 10px">请输入有效的公网IP地址。</span>-->
                    </div>
                </div>
                <div class="info-view-item">
                    <span>NTP服务器地址：</span>
                    <span v-if="!changePopShow">{{sysInfo.ntpAddress}}</span>
                    <el-input v-else size="mini" v-model="changePopInfo.ntpAddress" style="width: 150px"></el-input>
                </div>
                <div class="info-view-item">
                    <span>媒体服务器外网地址：</span>
                    <span v-if="!changePopShow">{{sysInfo.mediaServerWan}}</span>
                    <el-input v-else size="mini" v-model="changePopInfo.mediaServerWan" style="width: 150px"></el-input>
                </div>
                <div class="info-view-item">
                    <span>媒体服务器内网地址：</span>
                    <span v-if="!changePopShow">{{sysInfo.mediaServerLan}}</span>
                    <el-input v-else size="mini" v-model="changePopInfo.mediaServerLan" style="width: 150px"></el-input>
                </div>

                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!changePopShow && $store.getters.checkChangeAuth()"
                               @click="changePop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="changePopShow" @click="saveSysInfo(changePopInfo)">保存
                    </el-button>
                    <el-button size="small" type="info" v-if="changePopShow" @click="changePopShow = false">取消
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo" class="info-view" @keyup.enter="saveSysInfo(changePopInfo)">
            <div class="info-view-title">默认推流参数</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">配置应用默认推流参数</span>
                <div class="info-view-item">
                    <span>推流最小码率<span v-show="streamPopShow" style="color: red;">*</span>：</span>
                    <span v-if="!streamPopShow">{{sysInfo.encodeRateMin}} kb/s
             <el-tooltip effect="dark" placement="right">
            <div slot="content">调整云机推流时画面的最小码率，需输入100~8000的数字，<br/>默认为1000，必须小于等于推流最大码率。
            </div>
            <div class="question-icon">?</div>
          </el-tooltip>
          </span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.encodeRateMin"
                                  :style="{width: '150px', border: checkInfo.encodeRateMin ? '1px solid red' : ''}"></el-input>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">调整云机推流时画面的最小码率，需输入100~8000的数字，<br/>默认为1000，必须小于等于推流最大码率。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                        <span v-show="checkInfo.encodeRateMin" style="color: red;padding-left: 10px">请输入大于100并且小于推流最大码率和8000的数值。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>推流最大码率<span v-show="streamPopShow" style="color: red;">*</span>：</span>
                    <span v-if="!streamPopShow">{{sysInfo.encodeRateMax}} kb/s
            <el-tooltip effect="dark" placement="right">
              <div slot="content">调整云机推流时画面的最大码率，需输入1000~40000的整数，<br/>默认为2000，必须大于等于推流最小码率。
              </div>
              <div class="question-icon">?</div>
            </el-tooltip>
          </span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.encodeRateMax"
                                  :style="{width: '150px', border: checkInfo.encodeRateMax ? '1px solid red' : ''}"></el-input>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">调整云机推流时画面的最大码率，需输入1000~40000的整数，<br/>默认为2000，必须大于等于推流最小码率。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                        <span v-show="checkInfo.encodeRateMax" style="color: red;padding-left: 10px">请输入大于1000和最小推流码率并且小于40000的数值。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>推流帧率<span v-show="streamPopShow" style="color: red;">*</span>：</span>
                    <span v-if="!streamPopShow">{{sysInfo.framerate}}
            <el-tooltip effect="dark" placement="right">
              <div slot="content">调整云机推流时画面的帧率，需输入1-60的整数，默认为30。
              </div>
              <div class="question-icon">?</div>
            </el-tooltip>
          </span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.framerate"
                                  :style="{width: '150px', border: checkInfo.framerate ? '1px solid red' : ''}"></el-input>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">调整云机推流时画面的帧率，需输入1-60的整数，默认为30。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                        <span v-show="checkInfo.framerate" style="color: red;padding-left: 10px">请输入1-60的整数。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>摄像头上行帧率<span v-show="streamPopShow" style="color: red;">*</span>：</span>
                    <span v-if="!streamPopShow">{{sysInfo.cameraUpFrameRate}}
            <el-tooltip effect="dark" placement="right">
              <div slot="content">调整云机本地摄像头同步时的上行帧率，需输入1-60的整数，默认为30。
              </div>
              <div class="question-icon">?</div>
            </el-tooltip>
          </span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.cameraUpFrameRate"
                                  :style="{width: '150px', border: checkInfo.cameraUpFrameRate ? '1px solid red' : ''}"></el-input>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">调整云机本地摄像头同步时的上行帧率，需输入1-60的整数，默认为30。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                        <span v-show="checkInfo.cameraUpFrameRate"
                              style="color: red;padding-left: 10px">请输入1-60的整数。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>摄像头上行码率<span v-show="streamPopShow" style="color: red;">*</span>：</span>
                    <span v-if="!streamPopShow">{{sysInfo.cameraUpCodeRate}} kb/s
            <el-tooltip effect="dark" placement="right">
              <div slot="content">调整云机本地摄像头同步时的上行码率，需输入1000~40000的整数，默认为2000。
              </div>
              <div class="question-icon">?</div>
            </el-tooltip>
          </span>
                    <div v-else>
                        <el-input size="mini" v-model="changePopInfo.cameraUpCodeRate"
                                  :style="{width: '150px', border: checkInfo.cameraUpCodeRate ? '1px solid red' : ''}"></el-input>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">调整云机本地摄像头同步时的上行码率，需输入1000~40000的整数，默认为2000。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                        <span v-show="checkInfo.cameraUpCodeRate" style="color: red;padding-left: 10px">请输入1000~40000的整数。</span>
                    </div>
                </div>
                <div class="info-view-item">
                    <span>推流音频开关：</span>
                    <el-switch v-if="!streamPopShow" v-model="sysInfo.isVolume" :active-value="'1'"
                               :inactive-value="'2'"
                               :disabled="true" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-switch v-else size="mini" v-model="changePopInfo.isVolume" :active-value="'1'"
                               :inactive-value="'2'"
                               active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!streamPopShow && $store.getters.checkChangeAuth()"
                               @click="streamPop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="streamPopShow" @click="saveSysInfo(changePopInfo)">保存
                    </el-button>
                    <el-button size="small" type="info" v-if="streamPopShow" @click="streamPopShow = false">取消
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo && checkLicenseService(20) !== -1" class="info-view"
             @keyup.enter="saveSysInfo(changePopInfo)">
            <div class="info-view-title">登录安全设置</div>
            <div class="info-view-main">
                <div class="info-view-item">
                    <span>谷歌验证器验证：</span>
                    <!--<el-switch v-if="!loginPopShow" v-model="sysInfo.isGoogleAuthenticator" :active-value="'1'" :inactive-value="'0'"-->
                    <!--:disabled="true" active-color="#13ce66" inactive-color="#ff4949"></el-switch>-->
                    <span v-if="!loginPopShow">{{sysInfo.isGoogleAuthenticator | switchFilter}}</span>
                    <el-switch v-else size="mini" v-model="changePopInfo.isGoogleAuthenticator" :active-value="'1'"
                               :inactive-value="'0'"
                               active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-tooltip effect="dark" placement="right">
                        <div slot="content">谷歌验证器验证需手机安装谷歌验证器后登陆 google 账号绑定，<br/>
                            根据生成的验证码登陆安卓云管理系统进行两步验证。<br/>
                        </div>
                        <div class="question-icon">?</div>
                    </el-tooltip>
                </div>
                <div class="info-view-item">
                    <span>IP白名单验证：</span>
                    <!--<el-switch v-if="!loginPopShow" v-model="sysInfo.isGoogleAuthenticator" :active-value="'1'" :inactive-value="'0'"-->
                    <!--:disabled="true" active-color="#13ce66" inactive-color="#ff4949"></el-switch>-->
                    <span v-if="!loginPopShow">{{sysInfo.isIpWhiteList | switchFilter}}</span>
                    <el-switch v-else size="mini" v-model="changePopInfo.isIpWhiteList" :active-value="'1'"
                               :inactive-value="'0'"
                               active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-tooltip effect="dark" placement="right">
                        <div slot="content">IP 白名单需开启后在IP白名单内输入至少一个IP才能生效，<br/>
                            生效后仅白名单IP可登录系统。<br/>
                        </div>
                        <div class="question-icon">?</div>
                    </el-tooltip>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!loginPopShow && $store.getters.checkChangeAuth()"
                               @click="loginPop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="!loginPopShow && $store.getters.checkChangeAuth()"
                               @click="ipWhiteListPop()">IP白名单
                    </el-button>
                    <el-button size="small" type="primary" v-if="loginPopShow" @click="saveSysInfo(changePopInfo)">保存
                    </el-button>
                    <el-button size="small" type="info" v-if="loginPopShow" @click="loginPopShow = false">取消</el-button>
                </div>
            </div>
        </div>
        <!--<div v-if="sysInfo && licenseInfo && (licenseInfo.service.indexOf(10) !== -1 || licenseInfo.service.indexOf(11) !== -1 || licenseInfo.service.indexOf(12) !== -1)" class="info-view" @keyup.enter="saveSysInfo(changePopInfo)">-->
        <div v-if="sysInfo && (checkLicenseService(10) !== -1 ||  checkLicenseService(11) !== -1 || checkLicenseService(12) !== -1)"
             class="info-view" @keyup.enter="savePortOffset()">
            <div class="info-view-title">容器参数管理</div>
            <div class="info-view-main">
                <div class="info-view-item">
                    <span>NAT端口映射偏移：</span>
                    <span v-if="!portOffsetPopShow">{{portOffset}}</span>
                    <el-input v-else size="mini" v-model="portOffset" style="width: 150px"></el-input>
                    <el-tooltip effect="dark" placement="right">
                        <div slot="content">默认为10000，示例：<br/>
                            宿主机的端口映射为8088，则第一个容器的端口映射为18088，<br/>
                            第二个容器的端口为28088，以此类推。
                        </div>
                        <div class="question-icon">?</div>
                    </el-tooltip>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!portOffsetPopShow && $store.getters.checkChangeAuth()"
                               @click="portOffsetPopShow = true">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="portOffsetPopShow" @click="savePortOffset()">
                        保存
                    </el-button>
                    <el-button size="small" type="info" v-if="portOffsetPopShow" @click="portOffsetPopShow = false">取消
                    </el-button>
                </div>
            </div>
        </div>
        <div v-if="sysInfo" class="info-view">
            <div class="info-view-title">运维信息</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">配置运维邮箱和电话，接受预警信息</span>
                <div class="info-view-item" style="align-items: flex-start;height: auto">
                    <span style="height: 30px;line-height: 30px">运维邮箱：</span>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start">
                        <div v-for="(email, index) in emailList" :key="index"
                             style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;height: 30px">
                            <span v-if="!emailPopShow">{{email}}</span>
                            <div v-else
                                 style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
                                <el-input size="mini" v-model="emailList[index]" style="width: 150px"></el-input>
                                <i v-if="(index + 1) === emailList.length" class="iconfont"
                                   style="color: gray;margin-left: 3px;font-size: 18px" @click="emailAdd()">&#xe631;</i>
                                <i v-if="emailList.length !== 1" class="iconfont"
                                   style="color: gray;margin-left: 3px;font-size: 18px" @click="deleteEmail(index)">&#xe630;</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!emailPopShow && $store.getters.checkChangeAuth()"
                               @click="emailPop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="emailPopShow" @click="emailAddSave()">保存</el-button>
                    <el-button size="small" type="info" v-if="emailPopShow" @click="emailCancel()">取消</el-button>
                </div>
                <div class="info-view-item" style="align-items: flex-start;height: auto">
                    <span style="height: 30px;line-height: 30px">运维电话：</span>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start">
                        <div v-for="(phone, index) in phoneList" :key="index"
                             style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;height: 30px">
                            <span v-if="!phonePopShow">{{phone}}</span>
                            <div v-else
                                 style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
                                <el-input size="mini" v-model="phoneList[index]" style="width: 150px"></el-input>
                                <i v-if="(index + 1) === phoneList.length" class="iconfont"
                                   style="color: gray;margin-left: 3px;font-size: 18px" @click="phoneAdd()">&#xe631;</i>
                                <i v-if="phoneList.length !== 1" class="iconfont"
                                   style="color: gray;margin-left: 3px;font-size: 18px" @click="deletePhone(index)">&#xe630;</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-view-item-btn">
                    <el-button size="small" type="primary" v-if="!phonePopShow && $store.getters.checkChangeAuth()"
                               @click="phonePop()">设置
                    </el-button>
                    <el-button size="small" type="primary" v-if="phonePopShow" @click="phoneAddSave()">保存</el-button>
                    <el-button size="small" type="info" v-if="phonePopShow" @click="phoneCancel()">取消</el-button>
                </div>
            </div>
        </div>
        <div v-if="licenseInfo" class="info-view">
            <div class="info-view-title">License信息</div>
            <div class="info-view-main">
                <span class="info-view-item" style="font-size: 12px">查看和管理您的license凭证</span>
                <div class="info-view-item">
                    <span>license码：</span>
                    <el-tooltip effect="light" placement="right">
                        <div slot="content" style="width: 500px; height:400px; overflow-y: scroll">{{licenseInfo.code}}
                        </div>
                        <span style="max-width: 16em;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; ">{{licenseInfo.code}}</span>
                    </el-tooltip>

                </div>
                <div class="info-view-item">
                    <span>在线服务：</span>
                    <span v-if="licenseInfo.isAuthenticate">已认证</span>
                    <span v-else>未认证</span>
                </div>
                <div class="info-view-item">
                    <span style="font-weight: bold">License信息：</span>
                </div>
                <template v-if="licenseInfo.isNew">
                    <div class="info-view-item">
                        <span style="font-weight: bold">永久设备总数：</span>
                        <span>{{licenseInfo.deviceNumForever}}台</span>
                    </div>

                    <div class="info-view-item-list">
                        <span style="font-weight: bold">有效期设备数量：</span>
                        <div v-for="notForeverItem in licenseInfo.deviceNotForever">
                            <div class="device-notforever-item">
                                <span>{{notForeverItem.total}}台</span>
                                <span style="margin-left: 30px;">{{notForeverItem.seconds | secondsFilter}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="info-view-item-list">
                        <span style="font-weight: bold">永久配套服务信息：</span>
                        <div v-for="service in licenseInfo.serviceForever">
                            <div class="service-item">
                                <span>{{ serviceList[parseInt(service.serviceNo)]}}</span>
                                <span v-if="service.serviceNo == 10"
                                      style="margin-left: 5px">-{{service.max}}</span>
                                <span style="margin-left: 15px">{{service.total}}台</span>
                            </div>
                        </div>
                    </div>
                    <div class="info-view-item-list">
                        <span style="font-weight: bold">有效期配套服务信息：</span>
                        <div v-for="service in licenseInfo.serviceNotForever">
                            <div class="service-item">
                                <span>{{ serviceList[parseInt(service.serviceNo)]}}</span>
                                <span v-if="service.serviceNo == 10"
                                      style="margin-left: 5px">-{{service.max}}</span>
                                <span style="margin-left: 15px">{{service.total}}台</span>
                                <span style="margin-left: 15px">{{service.seconds | secondsFilter}}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="info-view-item">
                        <span>有效期：{{licenseInfo.secondsLeft | secondsFilter}}</span>
                    </div>
                    <div class="info-view-item">
                        <span>设备数量：{{licenseInfo.deviceNum}}</span>
                    </div>
                    <div class="info-view-item">
                        <span>预设虚拟化数量：{{containerNum}}</span>
                    </div>
                    <!--<div class="info-view-item">-->
                    <!--<span>容器镜像数量：</span>-->
                    <!--<span>{{mirrorNum}}</span>-->
                    <!--</div>-->
                    <div class="show-item" style="text-align: left;margin-top: 10px">配套服务：</div>
                    <div v-if="licenseInfo.service"
                         style="display: flex;flex-direction: row;flex-wrap: wrap;width: 430px">
                        <div class="show-item-child" v-for="(item,index) in serviceList" v-if="item.length > 0">{{item}}<i
                                :class="[checkLicenseService(index) === -1 ? 'el-icon-error' : 'el-icon-success']"
                                :style="{color: checkLicenseService(index) === -1 ? 'red' : 'green'}"></i></div>
                    </div>
                </template>

                <div class="license-btns-area">
                    <div class="info-view-item-btn" style="margin-right: 50px;">
                        <el-button size="small" type="primary" v-if="$store.getters.checkChangeAuth()"
                                   @click="license()">离线升级
                        </el-button>
                    </div>
                    <template v-if="!licenseInfo.isAuthenticate">
                        <div class="info-view-item-btn">
                            <el-button size="small" type="primary" v-if="$store.getters.checkChangeAuth()"
                                       @click="authOnline()">在线认证
                            </el-button>
                        </div>
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">在线认证可获得什么？<br/>
                                &nbsp;&nbsp;1.快速远程运维，一键提出问题，专人专员解决。<br/>
                                &nbsp;&nbsp;2.后台升级包OTA推送，升级无忧。 <br/>
                                &nbsp;&nbsp;3.设备故障提醒。
                            </div>
                            <div class="question-icon">?</div>
                        </el-tooltip>
                    </template>
                    <div class="info-view-item-btn" v-if="licenseInfo.isAuthenticate">
                        <el-button size="small" type="primary" v-if="$store.getters.checkChangeAuth()"
                                   @click="authOnline()">在线同步
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                :title="$store.state.isAdmin ? '龙境安卓云软件管理系统更新日志' : '请联系管理员升级管理系统'"
                :visible.sync="systemUpdate"
                :close-on-click-modal="true"
                :close-on-press-escape="true"
                :show-close="true"
                :center="true"
                :modal="false"
                width="650px">
            <div class="update-dialog-content">
                <div class="update-dialog-tips">
                    <span>升级⽅法：系统管理—>系统信息—>管理系统升级—>升级按钮</span>
                </div>
                <div class="system-package-content">
                    <template v-for="packageOne in systemPackageList">
                        <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;margin-top: 10px;">
                            <span style="font-weight: bold;margin-top: 10px;">{{packageOne.version}}</span>
                            <span style="margin-left: 30px;font-size: 12px;margin-top: 10px;">发布日期：{{packageOne.createTime | showDate}}</span>
                        </div>
                        <div style="width: 100%;text-align: left;margin-top: 10px;" v-html="packageOne.content">
                        </div>
                        <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 20px;margin-top: 10px;">
                            <span>下载地址：</span><a :href="packageOne.downloadUrl" target="_blank"
                                                 style="text-decoration: none;">{{packageOne.downloadUrl}}</a>
                        </div>
                    </template>
                </div>
            </div>
        </el-dialog>
        <el-dialog
                :visible.sync="engineUpdate"
                :close-on-click-modal="true"
                :close-on-press-escape="true"
                :show-close="true"
                :lock-scroll="true"
                :center="false"
                :modal="false"
                width="650px">
            <div slot="title" class="custom-box-title">
                {{$store.state.isAdmin ? '龙境安卓云云机更新日志' : '请联系管理员升级云机'}}
            </div>
            <div class="update-dialog-content">
                <div class="update-dialog-tips">
                    <span>注意：云机版本之间的升级包互不兼容，请根据当前拥有设备进⾏点击下载，
设备版本可在设备管理-设备列表-设备设备版本查看。</span>
                    <span>升级⽅法：系统管理-系统信息-设备引擎升级，点击上传升级包按钮，选择相
应版本的云机上传升级包，输⼊ MD5 后点击确定上传，上传完毕后点击设备升级按钮选择云机进⾏升级。</span>
                </div>
                <div class="engine-package-list">
                    <el-tabs v-model="engineTypeName" @tab-click="handleEngineTypeClick" class="el-tabs-style">
                        <el-tab-pane v-for="item in engineList" :label="item.engineTypeName"
                                     :name="item.engineTypeName">
                            <div class="engine-package-content" v-show="engineTypeName === item.engineTypeName">
                                <template v-for="packageOne in enginePackageListCurrent">
                                    <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;margin-top: 10px;">
                                        <span style="font-weight: bold;">{{packageOne.version}}</span>
                                        <span style="margin-left: 30px;font-size: 12px;">发布日期：{{packageOne.createTime | showDate}}</span>
                                    </div>
                                    <div style="width: 100%;text-align: left;margin-top: 10px;"
                                         v-html="packageOne.content">
                                    </div>
                                    <div style="display: flex;flex-direction: row;align-items: center;margin-top: 10px;">
                                        <span>MD5：</span><span>{{packageOne.md5}}</span>
                                    </div>
                                    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 20px;margin-top: 10px;">
                                        <span>下载地址：</span><a :href="packageOne.downloadUrl" target="_blank"
                                                             style="text-decoration: none;">{{packageOne.downloadUrl}}</a>
                                    </div>
                                </template>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </el-dialog>
        <!-- 上传升级包 -->
        <Drawer title="上传升级包" :visible.sync="engineFileUploadPopShow" @handClick="submitUpload"
                :before-close="engineUploadPopClose">
            <div v-if="engineFileUploadPopShow">
                <el-form ref="form" :model="engineUploadExtraInfo" label-width="130px" label-position="left">
                    <el-form-item size="mini" label="设备类型">
                        <div class="item-input">
                            <el-select v-model="engineUploadExtraInfo.engineType" size="small" placeholder="引擎版本">
                                <el-option
                                        v-for="item in bmEngineOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <!--<el-form-item size="mini" label="升级文件">-->
                    <!--<el-upload-->
                    <!--class="upload-demo"-->
                    <!--ref="upload"-->
                    <!--:headers="$store.getters.getHeaders"-->
                    <!--:action="$uri.system.engineUpdate"-->
                    <!--:data="engineUploadExtraInfo"-->
                    <!--:file-list="fileList"-->
                    <!--:limit="1"-->
                    <!--:multiple="false"-->
                    <!--:on-change="handleChange"-->
                    <!--:on-success="handleSuccess"-->
                    <!--:on-preview="handlePreview"-->
                    <!--:on-remove="handleRemove"-->
                    <!--:before-upload="handleUploadEngine"-->
                    <!--:on-progress="handleProgressEngine"-->
                    <!--:auto-upload="false">-->
                    <!--<el-button slot="trigger" size="small" type="primary">选取文件</el-button>-->
                    <!--</el-upload>-->
                    <!--</el-form-item>-->
                    <el-form-item size="mini" label="选择升级文件">
                    </el-form-item>
                    <div class="mater-upload-container">
                        <ChunkUpload
                                ref="upload"
                                :headers="$store.getters.getHeaders"
                                :chunk-size="chunkSize"
                                @upload_done="uploadFilesDone"
                                @upload_one="uploadOneFileDone"
                                @upload_fail="uploadOneFileFail"
                                @file_list="getFileListBeforeUpload"
                        >
                        </ChunkUpload>
                    </div>
                    <el-form-item size="mini" label="版本号" v-if="fileList.length">
                        <el-input v-model="engineUploadExtraInfo.versionName"></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="版本序号" v-if="fileList.length">
                        <el-input v-model="engineUploadExtraInfo.versionCode"></el-input>
                    </el-form-item>
                    <el-form-item size="mini" label="MD5" v-if="fileList.length">
                        <el-input v-model="engineUploadExtraInfo.md5"></el-input>
                    </el-form-item>
                    <el-checkbox v-model="engineUploadExtraInfo.isPrepare" v-if="fileList.length" true-label="1"
                                 false-label="0"
                    >云机预下载
                    </el-checkbox
                    >
                </el-form>
            </div>
        </Drawer>
        <!-- 引擎升级 -->
        <Drawer title="设备升级" :visible.sync="engineUpdatePopShow" @handClick="submitUpgrade"
                :before-close="engineUploadPopClose">
            <div v-if="engineUpdatePopShow">
                <el-form ref="form" :model="engineUpdateExtraInfo" label-width="130px" label-position="left">
                    <el-form-item size="mini" label="类型">
                        <div class="item-input">
                            <el-select v-model="engineUpdateExtraInfo.engineType" size="small" placeholder="引擎版本"
                                       @change="handleEngineTypeChange">
                                <el-option
                                        v-for="item in engineOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>

                    <div style="font-size: 15px;margin-bottom: 20px;margin-top: 10px;color: #333;">设备升级范围</div>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start; ">
                        <el-radio-group v-model="updateScope" size="mini"
                                        style="display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start;"
                                        @change="handleEngineTypeChange">
                            <el-radio :label="1" style="margin-bottom: 20px;">升级全部设备</el-radio>
                            <el-radio :label="0" style="margin-bottom: 20px;">升级指定分组设备
                            </el-radio
                            >
                            <el-radio :label="2" style="margin-bottom: 20px;">升级指定设备池设备</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="updateScope == 0" style="width: 100%; height: 600px;">
                        <el-scrollbar style="height:100%">
                            <el-tree
                                    ref="deviceTree"
                                    :props="props"
                                    :load="loadNode"
                                    :filter-node-method="filterNode"
                                    lazy
                                    highlight-current
                                    show-checkbox
                                    @check-change="handleGroupCheckChange">
                                <template slot-scope="{node}">
                                    <el-tooltip effect="light" :content="node.label" placement="top-start"
                                                style="font-size:14px;">
                                        <span v-if="node.disabled" slot="content">该设备已过保，无法进行升级，请联系运维人员</span>
                                        <span>{{node.label}}</span>
                                    </el-tooltip>
                                </template>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                    <div v-if="updateScope == 2" style="width: 100%; height: 600px;">
                        <el-scrollbar style="height:100%">
                            <el-tree
                                    ref="deviceCaseTree"
                                    :props="props"
                                    :load="loadDeviceCaseNode"
                                    :filter-node-method="filterNode"
                                    lazy
                                    highlight-current
                                    show-checkbox
                                    @check-change="handleCaseCheckChange">
                                <template slot-scope="{node}">
                                    <el-tooltip effect="light" :content="node.label" placement="top-start"
                                                style="font-size:14px;">
                                        <span v-if="node.disabled" slot="content">该设备已过保，无法进行升级，请联系运维人员</span>
                                        <span>{{node.label}}</span>
                                    </el-tooltip>
                                </template>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </el-form>
            </div>
        </Drawer>

        <!-- 引擎升级记录 -->
        <Drawer title="升级记录" :visible.sync="engineUpdateRecordPopShow" :opt="false">
            <div v-if="engineUpdateRecordPopShow">
                <el-form ref="form" size="mini" label-width="130px" label-position="left"
                         style="display: flex;flex-direction: column;height: 100%">
                    <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">当前引擎版本</div>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start">
                        <div style="display: flex;flex-direction: column;align-items: flex-start;font-size: 14px;color: #606266">
                            <template v-for="(item, index) in engineList">
                                <span :key="index" style="height: 26px;display: flex;align-items: center">{{item.engineTypeName}} - {{item.versionCode}}</span>
                            </template>
                        </div>
                    </div>
                    <div style="width: 100%;border-bottom: 1px solid #ddd;margin-top: 10px"></div>
                    <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">升级记录</div>
                    <template v-for="record in updateRecordList">
                        <el-form-item label="升级时间：" style="margin-bottom: 8px!important;" label-width="90px">
                            {{record.updateTime | formatDateTime}}
                        </el-form-item>
                        <el-form-item label="升级版本：" style="margin-bottom: 8px!important;" label-width="90px">
                            {{record.versionName}}
                        </el-form-item>
                        <el-form-item label="升级文件：" style="margin-bottom: 8px!important;" label-width="90px">
                            {{record.fileName}}
                        </el-form-item>
                        <el-form-item label="升级详情：" style="margin-bottom: 8px!important;" label-width="90px">
                            当前已升级{{record.upgradeNum}}路，
                            未升级<span style="color: red">{{record.notUpgradeNum}}</span>路。
                            <el-button type="text" size="mini" style="margin-left: 10px;display: inline"
                                       @click="engineUpdateRecordDetailPop(record)">查看详情
                            </el-button>
                        </el-form-item>
                        <div style="width: 100%;border-bottom: 1px solid #ddd;margin-top: 10px"></div>
                    </template>
                </el-form>
            </div>
        </Drawer>

        <!-- 引擎升级记录详情 -->
        <Drawer title="升级记录详情" :visible.sync="engineUpdateRecordDetailPopShow" :opt="false">
            <div v-if="engineUpdateRecordDetailPopShow">
                <el-form ref="form" size="mini" label-width="130px" label-position="left"
                         style="display: flex;flex-direction: column;height: 100%">
                    <el-form-item label="升级时间：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.updateTime | formatDateTime}}
                    </el-form-item>
                    <el-form-item label="升级版本：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.versionName}}
                    </el-form-item>
                    <el-form-item label="升级文件：" style="margin-bottom: 8px!important;" label-width="90px">
                        {{record.fileName}}
                    </el-form-item>
                    <el-form-item label="升级详情：" style="margin-bottom: 8px!important;" label-width="90px">
                        当前已升级{{record.upgradeNum}}路，
                        未升级<span style="color: red">{{record.notUpgradeNum}}</span>路。
                    </el-form-item>
                    <div style="width: 100%;border-bottom: 1px solid #ddd;margin-top: 10px"></div>
                    <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">未升级设备</div>
                    <div style="display: flex;justify-content: stretch;font-size: 14px;color: #606266">
                        <div style="width: 20%">设备池ID</div>
                        <div style="width: 30%">设备IP</div>
                        <div style="width: 25%">设备版本</div>
                        <div style="width: 25%">所属分组</div>
                    </div>
                    <div style="display: flex;justify-content: stretch;font-size: 14px;padding: 2px 0"
                         v-for="detail in detailNotUpdateList">
                        <div style="width: 20%">{{detail.caseNo}}</div>
                        <div style="width: 30%">{{detail.deviceIp}}</div>
                        <div style="width: 25%">{{detail.versionCode}}</div>
                        <div style="width: 25%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                            {{detail.groupName}}
                        </div>
                    </div>
                    <el-button type="text" size="mini" style="text-align: left;margin-top: 5px"
                               @click="completeShow = !completeShow">{{completeShow ? '&#9650点击收起已升级设备列表' :
                        '&#9660点击查看已升级设备列表'}}
                    </el-button>
                    <transition name="el-zoom-in-top">
                        <div v-show="completeShow">
                            <div style="font-size: 16px;margin-bottom: 5px;margin-top: 10px">已升级设备</div>
                            <div style="display: flex;justify-content: stretch;font-size: 14px;color: #606266">
                                <div style="width: 20%">设备池ID</div>
                                <div style="width: 30%">设备IP</div>
                                <div style="width: 25%">设备版本</div>
                                <div style="width: 25%">所属分组</div>
                            </div>
                            <div style="display: flex;justify-content: stretch;font-size: 14px;padding: 2px 0"
                                 v-for="detail in detailUpdateList">
                                <div style="width: 20%">{{detail.caseNo}}</div>
                                <div style="width: 30%">{{detail.deviceIp}}</div>
                                <div style="width: 25%">{{detail.versionCode}}</div>
                                <div style="width: 25%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
                                    {{detail.groupName}}
                                </div>
                            </div>
                        </div>
                    </transition>
                </el-form>
            </div>
        </Drawer>

        <!-- 管理系统升级 -->
        <Drawer title="管理系统升级" :visible.sync="systemUpdatePopShow" @handClick="systemUpgrade"
                :before-close="systemUploadPopClose">
            <div>
                <el-form ref="form" label-width="130px" label-position="left">
                    <el-form-item size="mini" label="系统当前版本">
                        <span>{{systemVersion}}</span>
                    </el-form-item>
                    <el-form-item size="mini" label="升级文件">
                        <el-upload
                                class="upload-demo"
                                ref="systemUpdateRef"
                                :headers="$store.getters.getHeaders"
                                :action="$uri.system.update"
                                :limit="1"
                                :multiple="false"
                                :on-success="handleSuccess2"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :before-upload="handleUploadSystem"
                                :on-progress="handleProgressSystem"
                                :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
        </Drawer>

        <Drawer title="数据库恢复" :visible.sync="recoverDatabasePopShow" @handClick="recoverDatabase">
            <div v-if="recoverDatabasePopShow" style="font-size: 13px">
                <div style="margin-bottom: 20px">当前管理端版本：{{systemVersion}}</div>
                <div>请选择需要恢复的数据库文件</div>
                <div style="margin: 10px 0 20px 0;color: red;font-size: 12px">
                    不同管理端版本的数据库恢复会造成系统不稳定，当前仅支持同管理端版本数据库进行恢复。
                </div>
                <el-table :data="databaseBackupList" ref="databaseBackupTable" size="mini" max-height="500px"
                          :highlight-current-row="true"
                          class="database-table"
                          @current-change="rowClickHandle" :row-class-name="rowClassName">
                    <el-table-column prop="systemVersion" label="版本"></el-table-column>
                    <el-table-column prop="createTime" label="备份日期"
                                     :formatter="databaseBackupDateFormat"></el-table-column>
                </el-table>
            </div>
        </Drawer>

        <Drawer title="IP白名单" :visible.sync="ipWhiteListPopShow" @handClick="ipWhiteListSave">
            <div v-if="ipWhiteListPopShow" style="font-size: 13px">
                <el-table :data="ipWhiteList" ref="ipWhiteListTable" size="mini" max-height="500px"
                          :highlight-current-row="true"
                          class="ipwhitelist-table">
                    <el-table-column prop="ip" min-width="150px" label="IP地址">
                        <template slot-scope="scope">
                            <!--<el-input v-model="scope.row.ip" size="mini" :disabled="!scope.row.edit"></el-input>-->
                            <el-input v-model="scope.row.ip" size="mini" v-if="scope.row.edit"></el-input>
                            <span v-else>{{scope.row.ip}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mask" min-width="150px" label="子网掩码">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.mask" size="mini" v-if="scope.row.edit"></el-input>
                            <span v-else>{{scope.row.mask}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100px" label="操作">
                        <template slot-scope="scope">
                            <!--<el-button type="text" size="small" @click.stop="editIpWhiteList(scope.row)">修改</el-button>-->
                            <!--<el-button type="text" size="small" @click.stop="deleteIpWhiteList(scope.row)">删除</el-button>-->
                            <el-button type="text" size="small" @click.stop="addIpRecord(scope.row)"
                                       v-if="scope.row.edit">确定
                            </el-button>
                            <el-button type="text" size="small" @click.stop="editIpWhiteList(scope.row)"
                                       v-if="!scope.row.edit">修改
                            </el-button>
                            <el-button type="text" size="small" @click.stop="deleteIpWhiteList(scope.row)"
                                       v-if="!scope.row.edit">删除
                            </el-button>
                        </template>

                    </el-table-column>

                </el-table>
                <el-button style="margin-top: 30px;" type="primary" size="small"
                           v-if="$store.getters.checkChangeAuth() || !$store.state.isAdmin"
                           @click.stop="addIpWhiteList()">添加
                </el-button>
            </div>
        </Drawer>
        <el-drawer
                ref="sync"
                title="文件分发清理"
                :visible.sync="fileIssueCleanPopShow"
                :append-to-body="true"
                size="450px"
                direction="rtl"
                :show-close="false"
                :destroy-on-close="true"
        >
            <div v-if="fileIssueCleanPopShow" style="font-size: 13px">
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-start;margin-left: 10px;">
                    <span style="color: #333">上传时间筛选：</span>
                    <el-date-picker
                            v-model="fileIssueDateValue"
                            type="daterange"
                            size="mini"
                            style="width: 300px;"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="getFileIssueList"
                            align="right"
                    >
                    </el-date-picker>
                </div>
                <el-table :data="fileIssueList" size="mini" :height="fileIssueTableHeight" ref="multipleTable"
                          :highlight-current-row="true" :header-cell-style="{backgroundColor: '#efefef'}"
                          class="fileissue-table" @row-click="checkRow"
                          tooltip-effect="dark" style="width: 100%;margin-top: 20px;"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" header-align="center"></el-table-column>
                    <el-table-column prop="fileName" min-width="120px" label="文件名" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" placement="top">
                                <span slot="content">{{scope.row.fileName}}</span>
                            </el-tooltip>
                            <span>{{scope.row.fileName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" min-width="80px" label="备注" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" placement="top">
                                <span slot="content">{{scope.row.remark}}</span>
                            </el-tooltip>
                            <span>{{scope.row.remark}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" min-width="150px" label="上传时间">
                    </el-table-column>
                </el-table>
                <div style="position: fixed;bottom: 0;padding: 10px 20px;border-top: thin solid #ddd;width: 100%;background-color: white;z-index: 200">
                    <el-button size="mini" type="primary" @click="fileIssueClean">清理</el-button>
                    <el-button size="mini" @click="fileIssueCleanPopShow = false">取消</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import ChunkUpload from '@/components/ChunkUpload.vue'

    let that
    export default {
        name: "SystemSetting",
        components: {
            Drawer, ChunkUpload
        },
        data() {
            return {
                chunkSize: 10 * 1024 * 1024,
                fileIssueTableHeight: 500,
                fileIssueDateValue: [],
                fileIssueCleanPopShow: false,
                fileIssueList: [],
                fileIssueCleanList: [],
                multipleSelection: [], // 选中的对象列表
                phoneModelSwitch: null,
                prepareDownLimit: 2000,
                resolve_head: null,
                node_head: null,
                props: {
                    label: 'name',
                    children: 'children',
                    isLeaf: 'leaf'
                },
                systemTypeSelected: "",
                isNodeSelected: "",
                systemTypeOptions: [
                    {
                        label: "黑金刚",
                        value: 1
                    }, {
                        label: "白武士",
                        value: 2
                    }
                ],
                isNodeOptions: [
                    {
                        label: "是",
                        value: 1
                    }, {
                        label: "否",
                        value: 0
                    }
                ],
                systemUpdate: false,
                engineUpdate: false,
                enginePackageList: [],
                systemPackageList: [],
                enginePackageListCurrent: [],
                engineTypeName: '',
                systemTypePopShow: false,
                userList: [],
                page: { // 分页参数
                    startPage: 1,
                    limit: 100
                },
                searchInfo: {
                    username: "",
                    groupId: ""
                },
                adminUserId: 1,
                adminUserName: '',
                staticToken: '',
                containerNum: 0,
                mirrorNum: 0,
                serviceList: ['命令转发', 'IP代理', '设备大师', '虚拟定位', 'ADB调试', '远程虚拟相机', '多开远程控制窗口', '电商推流直播', '音视频导入云机', '', '虚拟化容器', '', '', '', '', '', '', '', '', '', '后台安全认证', '音视频定点播放', '守护大师', '', '', '', '', '', '', '', '镜像备份'],
                recoverDatabasePopShow: false,
                databaseBackupList: [],
                ipWhiteList: [],
                newVersion: {
                    code: '',
                    content: ''
                },
                recoverId: null,
                sysInfo: null,
                checkInfo: null,
                regexMap: {
                    webIp: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
                    webMask: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
                    email: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                    phone: /^1\d{10}$/,
                    // ntpAddress: '/^((25[0-5]|2[0-4]\\d|[01]?\\d\\d?)($|(?!\\.$)\\.)){4}$/',
                    encodeRateMax: /^([1-3]\d{3,4}|[4-9]\d{3})$/,
                    // extranetIp: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
                    framerate: /^([0-5]\d|60|[1-9])$/,
                    // mediaServerWan: '/^((25[0-5]|2[0-4]\\d|[01]?\\d\\d?)($|(?!\\.$)\\.)){4}$/',
                    // mediaServerLan: '/^((25[0-5]|2[0-4]\\d|[01]?\\d\\d?)($|(?!\\.$)\\.)){4}$/',
                    webPort: /^[0-9]{1,5}$/,
                    encodeRateMin: /^([1-7][0-9]{2,3}|[89]\d{2})$/,
                    cameraUpFrameRate: /^([0-5]\d|60|[1-9])$/,
                    cameraUpCodeRate: /^([1-3]\d{3,4}|[4-9]\d{3})$/,
                    isVolume: /^[12]$/,
                    isCloseToken: /^[01]$/,
                    systemType: /^[12]$/,
                    isNode: /^[01]$/,
                    // closeTokenUserId: /^[0-9]{1,5}$/,
                },
                idInfo: null,
                changePopShow: false,
                prepareDownLimitPopShow: false,
                loginPopShow: false,
                ipWhiteListPopShow: false,
                streamPopShow: false,
                tokenPopShow: false,
                emailPopShow: false,
                portOffsetPopShow: false,
                portOffset: 10000,
                systemType: "",
                isNode: "",
                emailList: [],
                emailAddValue: '',
                phonePopShow: false,
                phoneList: [],
                phoneAddValue: '',
                changePopInfo: null,
                licenseInfo: null,
                systemVersion: '',
                engineVersionList: [],
                engineVersionDelList: [],
                engineVersionAddList: [],
                enginePopShow: false,
                versionAddInfo: {
                    code: '',
                    content: ''
                },

                engineUpdatePopShow: false,
                engineFileUploadPopShow: false,
                engineUploadTip: false,
                engineList: [],
                bmEngineList: [],
                engineUploadExtraInfo: {
                    file: "",
                    engineType: "",
                    versionName: "",
                    versionCode: "",
                    md5: "",
                    isPrepare: "1"
                },
                engineUpdateExtraInfo: {
                    engineType: "",
                    isAll: 1,
                    deviceIps: [],
                    isAllNew: false,
                },
                updateScope: 1,
                groupList: [],
                deviceCaseList: [],
                systemUpdatePopShow: false,
                fileList: [],
                engineUpdateRecordPopShow: false,
                updateRecordList: [],
                updateRecordDetail: [],
                engineUpdateRecordDetailPopShow: false,
                record: null,
                completeShow: false,
                usedSpace: 0,
                totalSpace: 1
            }
        },
        computed: {
            engineOptions() {
                let list = []
                this.engineList.forEach(v => {
                    list.push({
                        label: v.engineTypeName,
                        value: v.engineType
                    })
                })
                // console.log("dddsdfadf")
                return list
            },
            bmEngineOptions() {
                let list = []
                this.bmEngineList.forEach(v => {
                    list.push({
                        label: v.content,
                        value: v.code
                    })
                })
                // console.log("dddsdfadf")
                return list
            },
            detailUpdateList() {
                return this.updateRecordDetail.filter(d => {
                    console.log("d is " + JSON.stringify(d))
                    return d.isUpgrade > 0
                })
            },
            detailNotUpdateList() {
                return this.updateRecordDetail.filter(d => {
                    return d.isUpgrade === 0
                })
            },
        },
        watch: {
            fileList() {
                if (this.fileList.length) {
                    // console.log(this.fileList[0])
                    let name = this.fileList[0].name
                    let s = name.lastIndexOf('_')
                    let e = name.lastIndexOf('.')
                    let version = name.substr(s + 1, e - s - 1)
                    this.engineUploadExtraInfo.file = name
                    this.engineUploadExtraInfo.versionCode = version
                    this.engineUploadExtraInfo.versionName = version
                }
            }
        },
        filters: {
            showDate(dateItem) {
                var dateTime = new Date(dateItem)
                var year = dateTime.getFullYear(); //得到年份
                var month = dateTime.getMonth(); //得到月份
                var date = dateTime.getDate(); //得到日期
                month = month + 1;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                var defaultDate = `${year}-${month}-${date}`;//
                return defaultDate;
            },
            showSystemTypeName(value) {
                if (value == 1) {
                    return "黑金刚"
                } else {
                    return "白武士"
                }
            },
            showIsNode(value) {
                if (value == 1) {
                    return "是"
                } else {
                    return "否"
                }
            },
            switchFilter(value) {
                if (value == 1) {
                    return "开"
                } else {
                    return "关"
                }
            },
            secondsFilter(s) {
                if (s === -1) {
                    return '永久'
                } else if (s === 0) {
                    return "到期"
                }
                let time = ''
                let day = parseInt(s / (60 * 60 * 24))
                if (day > 0) {
                    time += day + '天'
                }
                s = s - day * (60 * 60 * 24)
                let hour = parseInt(s / (60 * 60))
                if (hour > 0) {
                    time += hour + '小时'
                }
                return time
            },
        },
        methods: {
            goUploadEnginePackage() {
                this.engineUploadExtraInfo = {
                    file: "",
                    engineType: "",
                    versionName: "",
                    versionCode: "",
                    md5: "",
                    isPrepare: "0"
                }
                this.engineFileUploadPopShow = true
            },
            getFileListBeforeUpload(files) {
                console.log("files is " + JSON.stringify(files))
                this.fileList = files
                if (this.fileList.length) {
                    // console.log(this.fileList[0])
                    let name = this.fileList[0].name
                    let s = name.lastIndexOf('_')
                    let e = name.lastIndexOf('.')
                    let version = name.substr(s + 1, e - s - 1)
                    this.engineUploadExtraInfo.file = name
                    this.engineUploadExtraInfo.versionCode = version
                    this.engineUploadExtraInfo.versionName = version
                }
            },
            uploadOneFileDone(file) {
                console.log("uploadOneFileDone file " + JSON.stringify(file))
                let that = this
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...that.engineUploadExtraInfo
                }
                console.log("body is " + JSON.stringify(body))
                that.$post(that.$uri.system.engineUpdateChunk, {...body}).then(res => {
                    console.log("engineUpdateChunk res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("上传成功---" + file.fileName)
                        that.engineFileUploadPopShow = false
                        // that.$refs.upload.clearOneFile(file.fileHash)
                    } else {
                        that.$message.error("上传失败---" + file.fileName)
                        that.engineFileUploadPopShow = false
                    }
                })
            },
            uploadFilesDone(file) {
                console.log("uploadFilesDone file " + JSON.stringify(file))
                let that = this
                // console.log("filaName " + file.fileName + " hash: " + file.fileHash)
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...that.engineUploadExtraInfo
                }
                console.log("body is " + JSON.stringify(body))
                that.$post(that.$uri.system.engineUpdateChunk, {...body}).then(res => {
                    console.log("engineUpdateChunk res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("上传完成---" + file.fileName)
                        that.$refs.upload.clearFiles()
                        that.engineFileUploadPopShow = false
                    }
                }).catch(() => {
                    that.$message.error("上传失败---" + file.fileName)
                    that.$refs.upload.clearFiles()
                    that.engineFileUploadPopShow = false
                })
            },
            uploadOneFileFail(errMsg) {
                console.log("upload fail: " + errMsg)
                this.$message.error("上传失败：" + errMsg)
                this.$refs.upload.clearFiles()
                this.engineFileUploadPopShow = false
            },
            goFileIssueClean() {
                this.getAllFileIssueList()
                this.fileIssueCleanPopShow = true
                this.$nextTick().then(() => {
                    if (this.$refs.multipleTable) {
                        this.fileIssueTableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 50;
                        // console.log("fileIssueTableHeight " + this.fileIssueTableHeight)
                    }
                })
            },
            /* 组内设备表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            getAllFileIssueList() {
                this.$post(this.$uri.file.fileList).then(res => {
                    if (res.success) {
                        this.fileIssueList = res.list
                        // console.log("fileIssueList is " + JSON.stringify(this.fileIssueList))
                    }
                })
            },
            getFileIssueList() {
                /* 获取操作日志列表 */
                if (!this.fileIssueDateValue) {
                    this.fileIssueDateValue = []
                }
                if (this.fileIssueDateValue.length > 0) {
                    this.searchInfo.updateTimeFrom = this.$util.formatDate(this.fileIssueDateValue[0])
                    this.searchInfo.updateTimeTo = this.$util.formatDate(this.fileIssueDateValue[1])
                }
                else {
                    this.searchInfo.updateTimeFrom = ""
                    this.searchInfo.updateTimeTo = ""
                }

                this.$post(this.$uri.file.fileList, {...this.searchInfo}).then(res => {
                    if (res.success) {
                        this.fileIssueList = res.list
                        // console.log("fileIssueList is " + JSON.stringify(this.fileIssueList))
                    }
                })
            },
            fileIssueClean() {
                if (this.multipleSelection.length == 0) {
                    this.$confirm("请勾选要清理的分发文件", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    let ids = []
                    this.multipleSelection.forEach(item => {
                        ids.push(item.id)
                    })
                    this.$confirm("确定要对勾选的分发文件进行清理？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$post(this.$uri.file.fileDel, {ids}).then(res => {
                            if (res.success) {
                                this.$message.success("清理分发文件成功")
                                if (this.fileIssueDateValue) {
                                    this.getFileIssueList()
                                } else {
                                    this.getAllFileIssueList()
                                }
                            }
                        })
                    }).catch(() => {
                    })
                }
            },
            cleanChunkFile() {
                this.$confirm("确定要对系统缓存的分片文件进行清理？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.$post(this.$uri.chunkUpload.deleteAll).then(res => {
                        if (res.success) {
                            this.$message.success("系统缓存清理命令发送成功")
                        }
                    })
                }).catch(() => {
                })
            },
            goCardUpdate() {
                this.$router.push('/home/system/cardupdate')
            },
            handleEngineTypeClick() {
                console.log("tab is " + this.engineTypeName);
                let newEnginePackageList = []
                this.enginePackageList.forEach(item => {
                    if (item.engineTypeName == this.engineTypeName) {
                        newEnginePackageList.push(item)
                    }
                })
                this.enginePackageListCurrent = JSON.parse(JSON.stringify(newEnginePackageList))
            },
            systemTypePop() {
                this.changePopInfo = JSON.parse(JSON.stringify(this.sysInfo))
                this.systemTypeSelected = this.sysInfo.systemType == 1 ? "黑金刚" : "白武士";
                this.isNodeSelected = this.sysInfo.isNode == 1 ? "是" : "否";
                // this.handleIsNodeChange(this.sysInfo.isNode)
                this.systemTypePopShow = true
            },
            handleSystemTypeChange(value) {
                // console.log("systemType is " + value)
                // console.log("systemTypeSelected " + that.systemTypeSelected)
                this.systemType = value
            },
            handleIsNodeChange(value) {
                // console.log("isNode is " + value)
                this.isNode = value
                if (value == 1) {
                    this.$store.commit(this.$mutation.IS_NEED_LAYER, true)
                } else {
                    this.$store.commit(this.$mutation.IS_NEED_LAYER, false)
                }
            },
            modelSwitchHandle() {
                let that = this
                that.$post(that.$uri.system.paramSave, that.phoneModelSwitch).then(res => {
                    if (res.success) {
                        // console.log("res is " + JSON.stringify(res))
                    }
                })
            },
            handleEngineTypeChange() {
                if (this.node_head) {
                    this.node_head.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
                    if (this.updateScope === 0) {
                        this.loadNode(this.node_head, this.resolve_head); //再次执行懒加载的方法
                    } else if (this.updateScope === 2) {
                        this.loadDeviceCaseNode(this.node_head, this.resolve_head); //再次执行懒加载的方法
                    }
                }
            },
            filterNode(value, data) {
                if (!value) return true;
                if (data && data.children && data.children.length > 0) {
                    return data.children.filter(item => {
                        return item.engineType == value
                    })
                } else {
                    return false
                }
            },
            getGroupList() {
                this.$post(this.$uri.group.list, {}).then(res => {
                    if (res.success) {
                        this.groupList = res.list
                        let newGroup = {}
                        newGroup.groupName = "未分组"
                        newGroup.id = 0
                        this.groupList.push(newGroup)
                    }
                })
            },
            /* 获取设备池列表 */
            getDeviceCaseList() {
                this.$post(this.$uri.device.caseList).then(res => {
                    // console.log("res is ", JSON.stringify(res))
                    if (res.success) {
                        this.deviceCaseList = res.list
                    }
                })
            },
            checkSelectedDeviceVersionNew(engineType, versionCode) {
                let isNew = false
                this.engineList.forEach(item => {
                    if (item.versionCode == versionCode && item.engineType == engineType) {
                        isNew = true
                        return
                    }
                })
                return isNew
            },
            handleGroupCheckChange(data, checked, indeterminate) {
                data.checked = checked
                let s = []
                let allNew = true
                this.groupList.forEach(g => {
                    g.children.forEach(c => {
                        if (g.checked || c.checked) {
                            s.push(c.deviceIp)
                            allNew &= this.checkSelectedDeviceVersionNew(c.engineType, c.versionCode)
                        }
                    })
                })
                this.engineUpdateExtraInfo.deviceIps = s.join(",")
                this.engineUpdateExtraInfo.isAllNew = allNew
            },
            handleCaseCheckChange(data, checked, indeterminate) {
                data.checked = checked
                let s = []
                let allNew = true
                this.deviceCaseList.forEach(g => {
                    g.children.forEach(c => {
                        if (g.checked || c.checked) {
                            s.push(c.deviceIp)
                            allNew &= this.checkSelectedDeviceVersionNew(c.engineType, c.versionCode)
                        }
                    })
                })
                this.engineUpdateExtraInfo.deviceIps = s.join(",")
                this.engineUpdateExtraInfo.isAllNew = allNew
            },
            showDeviceToolTip(data) {
                console.log("data is " + JSON.stringify(data))
            },
            loadNode(node, resolve) {
                let that = this
                let engineSelect = this.engineUpdateExtraInfo.engineType
                if (node.level === 0) {
                    this.node_head = node
                    this.resolve_head = resolve

                    this.groupList.forEach(g => {
                        g.name = g.groupName
                        g.checked = false
                        that.$post(that.$uri.device.deviceList, {groupId: g.id}).then(res => {
                            if (res.success) {
                                // console.log("deviceList res " + JSON.stringify(res))
                                let list = res.list
                                let newList = []
                                list.forEach(d => {
                                    // console.log("d is " + JSON.stringify(d))
                                    if (d.remark.length > 0) {
                                        d.name = d.deviceIp + "(" + d.remark + ")"
                                    } else {
                                        d.name = d.deviceIp
                                    }
                                    d.checked = false
                                    if (this.licenseInfo.hasOwnProperty("isNew") && this.licenseInfo.isNew == 1 && d.deviceUuid.length > 0 && d.isAuth !== 1) {
                                        d.disabled = true
                                    } else {
                                        d.disabled = false
                                    }
                                    d.leaf = true
                                    if (!engineSelect || d.engineType == engineSelect) {
                                        newList.push(d)
                                    }
                                })
                                g.children = newList
                                if (that.$refs.deviceTree) {
                                    that.$refs.deviceTree.filter(engineSelect);
                                }
                            }
                        })
                    })
                    return resolve(this.groupList);
                }
                if (node.level = 1) {
                    if (node.data) {
                        return resolve(node.data.children);
                    }
                    else {
                        return resolve([]);
                    }
                }
                if (node.level > 1) {
                    return resolve([]);
                }
            },
            loadDeviceCaseNode(node, resolve) {
                let that = this
                let engineSelect = this.engineUpdateExtraInfo.engineType
                // console.log("engineSelect is " + engineSelect)
                if (node.level === 0 && this.deviceCaseList) {
                    this.node_head = node
                    this.resolve_head = resolve

                    this.deviceCaseList.forEach(g => {
                        // if (!g.children) {
                        g.name = g.caseNo
                        g.checked = false
                        that.$post(that.$uri.device.deviceList, {caseNo: g.caseNo}).then(res => {
                            // console.log("caseList res " + JSON.stringify(res))
                            if (res.success) {
                                let list = res.list
                                let newList = []
                                list.forEach(d => {
                                    if (d.remark.length > 0) {
                                        d.name = d.deviceIp + "(" + d.remark + ")"
                                    } else {
                                        d.name = d.deviceIp
                                    }
                                    d.checked = false
                                    d.leaf = true
                                    if (this.licenseInfo.hasOwnProperty("isNew") && this.licenseInfo.isNew == 1 && d.deviceUuid.length > 0 && d.isAuth !== 1) {
                                        d.disabled = true
                                    }
                                    if (!engineSelect || d.engineType == engineSelect) {
                                        newList.push(d)
                                    }
                                })
                                g.children = newList
                                if (that.$refs.deviceCaseTree) {
                                    that.$refs.deviceCaseTree.filter(engineSelect);
                                }
                            }
                        })
                    })
                    return resolve(this.deviceCaseList);
                }
                if (node.level = 1) {
                    if (node.data) {
                        return resolve(node.data.children);
                    }
                    else {
                        return resolve([]);
                    }
                }
                if (node.level > 1) {
                    return resolve([]);
                }
            },
            cancelTokenSet() {
                this.getSysInfo()
                this.tokenPopShow = false
            },
            changeTokenUser(userName) {
                // console.log("userName is " + userName)
                this.userList.forEach(item => {
                    if (item.username == userName) {
                        this.changePopInfo.closeTokenUserId = item.id
                    }
                })
            },
            getStaticToken() {
                that.$post(that.$uri.system.staticToken, {}).then(res => {
                    // console.log("getStaticToken res is " + JSON.stringify(res))
                    if (res.success) {
                        that.adminUserId = res.data.userId
                        that.adminUserName = res.data.username
                        that.staticToken = res.data.token
                    }
                })
            },
            deleteIpWhiteList(row) {
                var id = row.id
                that.$post(that.$uri.ipWhiteList.delete, {id}).then(res => {
                    that.getIpWhiteList()
                })
            },
            editIpWhiteList(row) {
                // console.log("row is " + JSON.stringify(row))
                var ipWhiteListTmp = JSON.parse(JSON.stringify(this.ipWhiteList))
                this.ipWhiteList = ipWhiteListTmp.map(item => {
                    if (item.id == row.id) {
                        item.edit = true
                    }
                    return item
                })
                // console.log("ipwhiteList is " + JSON.stringify(this.ipWhiteList))
                // row.edit = true
            },
            getIpWhiteList() {
                that.$post(that.$uri.ipWhiteList.list, {}).then(res => {
                    that.ipWhiteList = res.list
                })
            },
            addIpRecord(row) {
                // console.log("row is " + JSON.stringify(row))
                let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
                if (!reg.test(row.ip) || !reg.test(row.mask)) {
                    that.$message.error("请填写正确的ip格式")
                    return
                }
                var record = {};
                record.ip = row.ip;
                record.mask = row.mask;
                if (row.id > 0) {
                    record.id = row.id;
                    // console.log("edit record is " + JSON.stringify(record))
                    that.$post(that.$uri.ipWhiteList.saveEdit, record).then(res => {
                        // console.log("res is " + JSON.stringify(res))
                        if (res.success) {
                            that.getIpWhiteList()
                        }
                    })
                } else {
                    // console.log("add record is " + JSON.stringify(record))
                    that.$post(that.$uri.ipWhiteList.saveAdd, record).then(res => {
                        // console.log("res is " + JSON.stringify(res))
                        if (res.success) {
                            that.getIpWhiteList()
                        }
                    })
                }

                row.edit = false
            },
            addIpWhiteList() {
                // console.log("add ipWhiteList")
                var newRecord = {
                    ip: '',
                    mask: '',
                    edit: true
                }
                this.ipWhiteList.push(newRecord)
            },
            handleProgressSystem(event, file, fileList) {
                if (!this.systemUploadTip) {
                    this.$refs.systemUpdateRef.abort(file)
                    this.$refs.systemUpdateRef.clearFiles()
                }
            },
            handleUploadSystem() {
                this.systemUploadTip = true
            },
            /* 系统升级 */
            systemUpgrade() {
                this.$refs.systemUpdateRef.submit();
            },
            handleSuccess2(response, file, fileList) {
                if (response.success) {
                    this.$refs.systemUpdateRef.clearFiles()
                    this.$message.success("升级成功")
                    this.systemUpdatePopShow = false
                    this.systemUpdatePopShow = false
                    this.systemUploadTip = false
                } else {
                    // console.log(response)
                    this.$message.error(response.message)
                    this.$refs.systemUpdateRef.clearFiles()
                }
            },
            systemUploadPopClose() {
                if (this.systemUploadTip) {
                    this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$refs.systemUpdateRef.clearFiles()
                        this.systemUpdatePopShow = false
                        this.systemUploadTip = false
                    }).catch(() => {
                    })
                } else {
                    this.$refs.systemUpdateRef.clearFiles()
                    this.systemUpdatePopShow = false
                    this.systemUploadTip = false
                }
            },
            engineUploadPopClose() {
                if (this.engineUploadTip) {
                    this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$refs.upload.clearFiles()
                        this.fileList = []
                        this.engineFileUploadPopShow = false
                        this.engineUploadTip = false
                    }).catch(() => {
                    })
                } else {
                    this.$refs.upload.clearFiles()
                    this.fileList = []
                    this.engineFileUploadPopShow = false
                    this.engineUploadTip = false
                }
            },
            /* 上传文件 */
            submitUpload() {
                this.$confirm("如果确认无误，请点击确认按钮上传升级包。", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.engineUploadTip = true
                    this.$refs.upload.handleUpload()
                    // this.$refs.upload.submit()
                }).catch(() => {
                });
            },
            submitUpgrade() {
                if (this.engineUpdateExtraInfo.engineType.length == 0) {
                    this.$confirm("请选择要升级的设备类型", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {

                    }).catch(() => {
                    })
                } else {
                    this.checkVersion()
                }
            },
            handleProgressEngine(event, file, fileList) {
                if (!this.engineUploadTip) {
                    this.$refs.upload.abort(file)
                    this.$refs.upload.clearFiles()
                }
            },
            handleChange(file, fileList) {
                this.fileList = fileList
            },
            handleSuccess(response, file, fileList) {
                // console.log("upload res is " + JSON.stringify(response))
                if (response.success) {
                    this.$refs.upload.clearFiles()
                    this.fileList = []
                    this.$message.success("上传成功")
                    this.engineFileUploadPopShow = false
                    this.engineUploadTip = false
                } else {
                    console.log("upload error: " + JSON.stringify(response))
                    this.$message.error(response.message)
                    this.$refs.upload.clearFiles()
                    this.fileList = []
                }
            },
            handleRemove(file, fileList) {
                // console.log(file, fileList);
            },
            handlePreview(file) {
                // console.log(file);
            },
            handleUploadEngine() {
                this.engineUploadTip = true
                // console.log("this.engineUploadExtraInfo.is " + JSON.stringify(this.engineUploadExtraInfo))
            },
            /* 获取引擎列表 */
            getEngineList() {
                this.$post(this.$uri.system.engineList, {}).then(res => {
                    if (res.success) {
                        this.engineList = res.data
                    }
                    // console.log("engineList " + JSON.stringify(that.engineList))
                })
            },
            getBmEngineList() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    this.bmEngineList = res.list
                    // console.log("bmEngineList " + JSON.stringify(that.bmEngineList))
                })
            },
            /* 版本检查 */
            checkVersion() {
                let msg = ""
                if (this.engineUpdateExtraInfo.isAllNew) {
                    msg = "当前选择云机均已升级为最新版，无需再次升级，请确认云机升级包是否为最新"
                } else {
                    if (this.updateScope == 1) {
                        msg = "确认对所有设备进行版本升级？"
                        this.engineUpdateExtraInfo.isAll = 1
                    } else {
                        msg = "确认对当前指定设备进行版本升级？"
                        this.engineUpdateExtraInfo.isAll = 0
                    }
                }

                this.$confirm(msg, "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    if (!this.engineUpdateExtraInfo.isAllNew) {
                        let that = this
                        // console.log("engineUpdateExtraInfo is " + JSON.stringify(that.engineUpdateExtraInfo))
                        that.$post(that.$uri.system.engineVersionCheck, that.engineUpdateExtraInfo).then(res => {
                            if (res.success) {
                                that.$message.success("发送成功")
                            }
                            that.engineUpdatePopShow = false
                            that.engineUpdateExtraInfo.engineType = ""
                            that.engineUpdateExtraInfo.isAll = 1
                            that.engineUpdateExtraInfo.deviceIps = []
                            that.engineUpdateExtraInfo.isAllNew = false
                        })
                    }
                }).catch(() => {
                }).finally(() => {

                })
            },
            checkSystemUpdate() {
                this.getSystemPackageList();
            },
            checkEngineUpdate() {
                this.getEnginePackageList();
                this.engineUpdate = true;
                this.engineTypeName = this.engineList[0].engineTypeName
                this.handleEngineTypeClick()
            },
            getEnginePackageList() {
                this.$post(this.$uri.system.enginePackage).then(res => {
                    console.log("getEnginePackageList res " + JSON.stringify(res))
                    if (res.success) {
                        this.enginePackageList = res.list
                    }
                }).finally(() => {
                    console.log("getEnginePackageList done")
                })
            },
            getSystemPackageList() {
                this.$post(this.$uri.system.systemPackage).then(res => {
                    console.log("getSystemPackageList res is " + JSON.stringify(res))
                    if (res.success) {
                        this.systemPackageList = res.list
                        this.systemUpdate = true;
                    } else {
                        setTimeout(() => {
                            this.$message({
                                message: "获取更新信息失败:" + res.message,
                                type: 'error',
                                duration: 3000
                            });
                        }, 10)
                    }
                })
            },
            engineUpdateRecordPop() {
                let that = this
                that.$post(that.$uri.system.updateRecord).then(res => {
                    if (res.success) {
                        that.updateRecordList = res.list
                        that.engineUpdateRecordPopShow = true
                    }
                })
            },
            engineUpdateRecordDetailPop(record) {
                let that = this
                that.$post(that.$uri.system.updateRecordDetail, {engineUpgradeId: record.id}).then(res => {
                    if (res.success) {
                        that.updateRecordDetail = res.list
                        that.record = record
                        that.completeShow = false
                        that.engineUpdateRecordDetailPopShow = true
                    }
                })
            },

            versionAdd() {
                let that = this
                if (this.newVersion.code.length > 0 && this.newVersion.content.length > 0) {
                    this.engineVersionAddList.push(JSON.parse(JSON.stringify(this.newVersion)))
                    this.newVersion.code = ''
                    this.newVersion.content = ''
                }
                for (let i = 0; i < this.engineVersionAddList.length; i++) {
                    if (!/^[0-9]{1,4}$/.test(this.engineVersionAddList[i].code) || !/^[0-9a-zA-Z_]{1,20}$/.test(this.engineVersionAddList[i].content)) {
                        that.$message.error("请按正确的格式输入参数")
                        return
                    }
                }

                this.engineVersionList.forEach(version => {
                    that.$post(that.$uri.system.engineCodeChange, version).then(res => {
                        if (res.success) {
                            this.getEngineVersionList()
                            this.getEngineList()
                        } else {
                            // that.$message.error("添加失败，错误信息：" + res.message + "，错误码： " + res.code)
                        }
                    })
                })

                this.engineVersionAddList.forEach(version => {
                    that.$post(that.$uri.system.engineCodeAdd, version).then(res => {
                        if (res.success) {
                            this.getEngineVersionList()
                            this.getEngineList()
                        } else {
                            // that.$message.error("添加失败，错误信息：" + res.message + "，错误码： " + res.code)
                        }
                    })
                    this.engineVersionAddList = []
                })

                this.engineVersionDelList.forEach(version => {
                    that.$post(that.$uri.system.engineCodeDelete, version).then(res => {
                        if (res.success) {
                            this.getEngineVersionList()
                            this.getEngineList()
                        } else {
                            // that.$message.error("删除失败，错误信息：" + res.message + "，错误码： " + res.code)
                        }
                    })
                    this.engineVersionDelList = []
                })
                this.$message.success("修改完成")
                this.enginePopShow = false
            },
            versionAddCancel() {
                this.enginePopShow = false
                this.getEngineVersionList()
                this.engineVersionAddList = []
                this.engineVersionDelList = []
            },
            backupDatabase() {
                this.$loading()
                this.$post(this.$uri.database.backup).then(res => {
                    if (res.success) {
                        this.$message.success('备份成功')
                    } else {
                        this.$message.error('备份失败')
                    }
                }).finally(() => {
                    this.$loading().close()
                })
            },
            recoverDatabasePop() {
                this.$post(this.$uri.database.list).then(res => {
                    if (res.success) {
                        this.databaseBackupList = res.list
                        this.recoverDatabasePopShow = true
                        this.$nextTick().then(() => {
                            let res = this.databaseBackupList.filter(backup => backup.systemVersion === this.systemVersion)
                            if (res.length) {
                                this.recoverId = res[0].id
                                this.$refs.databaseBackupTable.setCurrentRow(res[0])
                            }
                        })
                    } else {
                        this.$message.error('系统异常')
                    }
                })
            },
            recoverDatabase() {
                if (!this.recoverId) {
                    this.$message.error('未选择备份记录')
                    return
                }
                this.$loading()
                this.$post(this.$uri.database.restore, {id: this.recoverId}).then(res => {
                    if (res.success) {
                        this.$message.success('恢复成功')
                        this.recoverDatabasePopShow = false
                    } else {
                        this.$message.error('恢复失败')
                    }
                }).finally(() => {
                    this.$loading().close()
                })
            },
            rowClickHandle(n, o) {
                if (n.systemVersion !== this.systemVersion) {
                    this.$refs.databaseBackupTable.setCurrentRow(o)
                } else {
                    this.recoverId = n.id
                }
            },
            rowClassName({row}) {
                return row.systemVersion === this.systemVersion ? 'click' : 'not-click'
            },
            databaseBackupDateFormat(r, c, cv, index) {
                return this.$formatDate(new Date(r.createTime))
            },
            getEngineVersionList() {
                that.$post(that.$uri.system.engineCodeList).then(res => {
                    if (res.success) {
                        that.engineVersionList = res.list
                    }
                })
            },
            license() {
                this.$store.commit(this.$mutation.LICENSE_UPDATE, true)
            },
            authOnline() {
                // console.log("auth online ")
                this.$post(this.$uri.system.licenseOnLine).then(res => {
                    if (res.success) {
                        this.$notify({
                            title: '在线同步成功',
                            message: "",
                            type: 'success'
                        });
                        this.getLicense()
                    } else {
                        this.$notify({
                            title: '在线同步失败',
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            },
            getSystemVersion() {
                that.$post(that.$uri.system.paramVersion, {}).then(res => {
                    that.systemVersion = res.data
                })
            },
            getSysInfo() {
                this.$post(this.$uri.system.paramList, {}).then(res => {
                    if (res.success) {
                        console.log("sysInfo is " + JSON.stringify(res))
                        let idInf = {}
                        let paramInf = {}
                        let checkInf = {}
                        res.list.forEach(item => {
                            idInf[item.paramName] = item.id
                            paramInf[item.paramName] = item.paramValue
                            checkInf[item.paramName] = false
                            if (item.paramName === "isBrandLocal") {
                                this.phoneModelSwitch = item
                            }
                            if (item.paramName === "prepareDownLimit") {
                                this.prepareDownLimit = item.paramValue
                            }
                            if (item.paramName === "portOffset") {
                                this.portOffset = item.paramValue
                            }
                            if (item.paramName === "systemType") {
                                this.systemType = item.paramValue
                            }
                            if (item.paramName === "isNode") {
                                this.isNode = item.paramValue
                            }
                        })
                        this.sysInfo = paramInf
                        // console.log("sysInfo is " + JSON.stringify(that.sysInfo))
                        this.checkInfo = checkInf
                        this.idInfo = idInf
                        this.emailList = this.sysInfo.email.split(',')
                        this.phoneList = this.sysInfo.phone.split(',')
                        if (this.sysInfo.isCloseToken == 1) {
                            this.getStaticToken()
                        } else {
                            this.adminUserName = ''
                            this.staticToken = ''
                        }
                    }
                })
            },
            checkLicenseService(index) {
                let found = -1
                if (this.licenseInfo && this.licenseInfo.service) {
                    let serviceItems = this.licenseInfo.service.toString().split(",")
                    serviceItems.forEach(item => {
                        // console.log("item is " + item + ", index is " + index)
                        if (item == index) {
                            found = 1
                            return
                        }
                    })
                }
                return found
            },
            getLicense() {
                let licenseNew = {}
                this.$post(this.$uri.system.licenseGet).then(res => {
                    if (res.success) {
                        licenseNew = res.data
                        if (licenseNew.hasOwnProperty("isNew") && licenseNew.isNew == 1) {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)
                            }

                            if (licenseNew.service) {
                                let serviceItems = licenseNew.service.toString().split(",")
                                // console.log("serviceItems is " + serviceItems)
                                serviceItems.forEach(item => {
                                    if (item == 0) {
                                        this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                    } else if (item == 1) {
                                        this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                    } else if (item == 2) {
                                        this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                    } else if (item == 30) {
                                        this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                    }
                                })
                            }
                        } else {
                            if (licenseNew.secondsLeft === 0) {
                                // console.log("license secondsLeft is 0")
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, true)
                            } else {
                                this.$store.commit(this.$mutation.IS_NEED_LICENSE, false)

                                this.mirrorNum = 0
                                this.containerNum = 0
                                if (licenseNew.service) {
                                    let serviceItems = licenseNew.service.toString().split(",")
                                    // console.log("serviceItems is " + serviceItems)
                                    serviceItems.forEach(item => {
                                        // console.log("item is " + item)
                                        if (item == 0) {
                                            this.$store.commit(this.$mutation.ENABLE_CMD_FORWARD)
                                        } else if (item == 1) {
                                            this.$store.commit(this.$mutation.ENABLE_IP_PROXY)
                                        } else if (item == 2) {
                                            this.$store.commit(this.$mutation.ENABLE_DEV_MASTER)
                                        } else if (item == 10) {
                                            this.containerNum = 1
                                        } else if (item == 11) {
                                            this.containerNum = 2
                                        } else if (item == 12) {
                                            this.containerNum = 3
                                        } else if (item == 30) {
                                            this.mirrorNum = 3
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        } else if (item == 31) {
                                            this.mirrorNum = 5
                                            this.$store.commit(this.$mutation.ENABLE_CONTAINER_MIRROR);
                                        }
                                    })
                                }
                            }
                        }
                        this.$store.commit(this.$mutation.LICENSE_SAVE, licenseNew)
                        this.$store.commit(this.$mutation.ENABLE_PHONE_MODEL)

                        // console.log("licenseInfo is " + JSON.stringify(licenseNew))
                        this.licenseInfo = JSON.parse(JSON.stringify(licenseNew))
                    }
                })
            },
            changePop() {
                that.changePopInfo = JSON.parse(JSON.stringify(that.sysInfo))
                that.changePopShow = true
            },

            prepareDownLimitPop() {
                this.changePopInfo = JSON.parse(JSON.stringify(this.sysInfo))
                this.prepareDownLimitPopShow = true
            },
            loginPop() {
                that.changePopInfo = JSON.parse(JSON.stringify(that.sysInfo))
                that.loginPopShow = true
            },
            ipWhiteListPop() {
                that.getIpWhiteList()
                that.ipWhiteListPopShow = true
            },
            streamPop() {
                that.changePopInfo = JSON.parse(JSON.stringify(that.sysInfo))
                that.streamPopShow = true
            },
            tokenPop() {
                that.changePopInfo = JSON.parse(JSON.stringify(that.sysInfo))
                that.tokenPopShow = true
            },
            ipWhiteListSave() {
                this.ipWhiteListPopShow = false
            },
            saveSysInfo(info) {
                console.log("saveSysInfo: " + JSON.stringify(info))
                let sign = true
                let ps = []
                for (let key in info) {
                    // console.log("key is " + key)
                    if (info[key] !== that.sysInfo[key]) {
                        let temp = {
                            id: that.idInfo[key],
                            paramName: key,
                            paramValue: info[key]
                        }
                        if (key === 'isCloseToken') {
                            // console.log("adminUserName is " + that.adminUserName)
                            if (parseInt(info[key]) === 1 && !that.adminUserName) {
                                sign = false
                                that.$confirm("请选择使用静态token的用户", "提示", {
                                    confirmButtonText: '确定',
                                    confirmButtonClass: 'confirm-btn-blue',
                                    iconClass: 'el-icon-c-blue',
                                    showCancelButton: false
                                }).then(() => {
                                }).catch(() => {
                                });
                            }
                        }
                        else if (that.regexMap[temp.paramName] && !that.regexMap[temp.paramName].test(temp.paramValue)) {
                            // console.log(temp.paramValue)
                            sign = false
                            that.checkInfo[temp.paramName] = true
                        } else if (key === 'encodeRateMax') {
                            if (parseInt(info[key]) < parseInt(info['encodeRateMin'])) {
                                sign = false
                                that.checkInfo[temp.paramName] = true
                            }
                        } else if (key === 'encodeRateMin') {
                            if (parseInt(info[key]) > parseInt(info['encodeRateMax'])) {
                                // console.log('min')
                                // console.log(info[key])
                                // console.log(info['encodeRateMax'])
                                sign = false
                                that.checkInfo[temp.paramName] = true
                            }
                        }
                        ps.push(temp)
                    }
                }
                if (sign) {
                    let aps = []
                    ps.forEach(t => {
                        // console.log("t is " + JSON.stringify(t))
                        aps.push(that.$post(that.$uri.system.paramSave, t))
                    })
                    Promise.all(aps).then().catch().finally(() => {
                        that.getSysInfo()
                        that.changePopShow = false
                        that.streamPopShow = false
                        that.tokenPopShow = false
                        that.loginPopShow = false
                        that.systemTypePopShow = false
                    })
                }
            },
            deleteEmail(index) {
                that.emailList.splice(index, 1)
            },
            deletePhone(index) {
                that.phoneList.splice(index, 1)
            },
            emailPop() {
                that.emailList = that.sysInfo.email.split(',')
                that.emailPopShow = true
            },
            emailAdd() {
                that.emailList.push('')
            },
            emailAddSave() {
                let check = false
                that.emailList.forEach(phone => {
                    if (!that.regexMap.email.test(phone)) {
                        check = true
                    }
                })
                if (check) {
                    that.$message.warning("请输入有效的邮箱地址")
                    return
                }
                let temp = {
                    id: that.idInfo.email,
                    paramName: 'email',
                    paramValue: that.emailList.join(',')
                }
                that.$post(that.$uri.system.paramSave, temp).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("修改成功")
                        that.getSysInfo()
                        that.emailPopShow = false
                    } else {
                        that.$message.error("修改失败")
                    }
                })
            },
            savePortOffset() {
                let temp = {
                    id: this.idInfo['portOffset'],
                    paramName: 'portOffset',
                    paramValue: this.portOffset
                }
                console.log("param is " + JSON.stringify(temp))
                this.$post(this.$uri.system.paramSave, temp).then(res => {
                    console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        this.$message.success("修改成功")
                        this.getSysInfo()
                        this.portOffsetPopShow = false
                    } else {
                        this.$message.error("修改失败")
                    }
                })
            },
            async saveSystemType() {
                let temp = {
                    id: this.idInfo['systemType'],
                    paramName: 'systemType',
                    paramValue: this.systemType
                }

                await this.$post(this.$uri.system.paramSave, temp)

                let temp2 = {
                    id: this.idInfo['isNode'],
                    paramName: 'isNode',
                    paramValue: this.isNode
                }
                await this.$post(this.$uri.system.paramSave, temp2)

                this.$message.success("修改成功")
                this.getSysInfo()
                this.systemTypePopShow = false
            },

            savePrepareDownLimit() {
                let temp = {
                    id: this.idInfo['prepareDownLimit'],
                    paramName: 'prepareDownLimit',
                    paramValue: this.prepareDownLimit
                }
                this.$post(this.$uri.system.paramSave, temp).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        this.$message.success("修改成功")
                        this.getSysInfo()
                        this.prepareDownLimitPopShow = false
                    } else {
                        this.$message.error("修改失败")
                    }
                })
            },
            phonePop() {
                that.phoneList = that.sysInfo.phone.split(',')
                that.phonePopShow = true
            },
            phoneAdd() {
                that.phoneList.push('')
            },
            phoneCancel() {
                that.getSysInfo()
                that.phonePopShow = false
            },
            emailCancel() {
                that.getSysInfo()
                that.emailPopShow = false
            },
            phoneAddSave() {
                let check = false
                that.phoneList.forEach(phone => {
                    if (!that.regexMap.phone.test(phone)) {
                        check = true
                    }
                })
                if (check) {
                    that.$message.warning("请输入有效的手机号")
                    return
                }
                let temp = {
                    id: that.idInfo.phone,
                    paramName: 'phone',
                    paramValue: that.phoneList.join(',')
                }
                that.$post(that.$uri.system.paramSave, temp).then(res => {
                    if (res.success) {
                        that.$message.success("修改成功")
                        that.getSysInfo()
                        that.phonePopShow = false
                    } else {
                        that.$message.error("修改失败")
                    }
                })
            },
            /* 获取用户列表 */
            getUserList() {
                let that = this
                that.$post(that.$uri.user.list, {...that.page, ...that.searchInfo}).then(res => {
                    // console.log("userList is " + JSON.stringify(res))
                    if (res.success) {
                        that.userList = res.list
                    }
                })
            },
            getDiskSpace() {
                this.$post(this.$uri.system.diskSpace).then(res => {
                    // console.log("getDiskSpace res is " + JSON.stringify(res))
                    if (res.success) {
                        this.usedSpace = res.data.usedSpace
                        this.totalSpace = res.data.totalSpace
                    }
                })
            }
        },
        beforeCreate() {
            that = this
        },

        mounted() {
            this.getSysInfo()
            this.getDiskSpace()
            this.getLicense()
            this.getSystemVersion()
            this.getEngineVersionList()
            this.getEngineList()
            this.getBmEngineList()
            this.getGroupList()
            this.getDeviceCaseList()
            this.getUserList()
        }
    };
</script>

<style lang="less" scoped>
    .info-view {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 10px;
        border-bottom: 1px solid #E1E6EB;
        .info-view-title {
            text-align: left;
            font-size: 14px;
            font-weight: 600;
            padding: 5px 10px;
        }
        .info-view-main {
            padding: 10px 10px 10px 120px;
            font-size: 12px;
            display: flex;

            flex-direction: column;
            align-items: left;
            justify-content: flex-start;
            .info-view-item {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding: 2px 0;
                height: 30px;
            }
            .info-view-item-list {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                .service-item, .device-notforever-item {
                    display: flex;
                    flex-direction: row;
                    padding: 2px 0px 2px 20px;
                    height: 20px;
                    align-items: center;
                    justify-content: center;
                }
            }
            .info-view-item-btn {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                padding: 5px 0;
            }
        }
    }

    .engine-info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .engine-version {
            display: flex;
            flex-direction: column;
            padding: 0 10px;
            span {
                color: #333;
                font-size: 12px;
            }
        }
    }

    .database-table /deep/ .not-click {
        background-color: #F5F7FA;
    }

    .database-table /deep/ .click {

    }

    .license-btns-area {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-top: 30px;
    }

    .show-item-child {
        font-size: 12px;
        width: 140px;
        padding: 3px 30px 3px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 16px;
        }
    }

    .question-icon {
        margin-left: 5px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        border-radius: 50%;
        background-color: grey;
        color: white;
        display: inline-block;
        position: relative;
    }

    .el-tree > .el-tree-node {
        min-width: 100%;
        display: inline-block;
    }

    .model-switch {
        margin-left: 10px;
    }

    .update-dialog-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .update-dialog-tips {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            span {
                color: red;
                text-align: left;
                font-size: 12px;
            }
        }
    }

    .el-tabs-style {
        margin-top: 10px;
        width: 500px;
        /*overflow-x: auto;*/
    }

    .engine-package-list {
        /*margin-top: 20px;*/
        width: 100%;
        height: 360px;
        /*overflow-y: auto;*/
        .engine-package-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            height: 300px;
            overflow-y: scroll;
        }
        .engine-package-content::-webkit-scrollbar {
            display: none
        }
    }

    .system-package-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: 300px;
        overflow-y: scroll;
    }

    .system-package-content::-webkit-scrollbar {
        display: none
    }

    .custom-box-title {
        font-size: 16px;
        font-weight: bold;
    }

    .mater-upload-container {
        border: none;
        max-height: 500px;
        margin-bottom: 30px;
    }
</style>